import {
	CheckoutOrderFragment,
	GdsService_OrderAdditionalServiceGdsServicePriceFreeze_Fragment,
	GdsServicesFragment,
	GdsServiceVipSubType,
	OrderAdditionalServiceGdsServiceServiceType,
	OrderAdditionalServiceGdsServiceVip,
	TravellerGdsService,
	TravellerSelectedServices
} from '@websky/graphql';

export const isFareLockService = (
	service: GdsServicesFragment['services'][0]
): service is GdsService_OrderAdditionalServiceGdsServicePriceFreeze_Fragment => {
	return service.isPriceFreeze || 'freezeUntil' in service;
};

export const isRefundOptionService = (
	service: GdsServicesFragment['services'][0]
): service is OrderAdditionalServiceGdsServiceVip => {
	return (
		service.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
		(service as OrderAdditionalServiceGdsServiceVip).subType === GdsServiceVipSubType.RefundableTicket
	);
};

export const getRefundOptionService = (order: CheckoutOrderFragment) => {
	return order?.additionalServices.gdsServices?.services.find(isRefundOptionService);
};

export const getIsRefundOptionSelected = (order: CheckoutOrderFragment) => {
	const refundOptionService = getRefundOptionService(order);

	return order?.travellers?.some(traveller =>
		traveller?.services?.gdsServices?.services?.some(service => service?.serviceId === refundOptionService?.id)
	);
};

export const getParamsForSaveOrderServicesMutation = (
	order: CheckoutOrderFragment,
	optionService: GdsServicesFragment['services'][0],
	action: 'add' | 'remove'
) => {
	const travellerServices: TravellerSelectedServices[] = [];

	order.travellers.forEach(traveller => {
		const gdsServices: TravellerGdsService = {};
		const allowedPassengers = Array.prototype.concat.apply([], optionService?.allowedPassengers);

		if (!allowedPassengers.includes(traveller.id)) {
			return;
		}

		if (action === 'add') {
			gdsServices.addServices = [
				{
					count: 1,
					segmentIds: Array.prototype.concat.apply([], optionService.allowedSegments),
					serviceId: optionService.id
				}
			];
		} else {
			gdsServices.setServices = [
				{
					count: 0,
					segmentIds: Array.prototype.concat.apply([], optionService.allowedSegments),
					serviceId: optionService.id
				}
			];
		}

		travellerServices.push({
			travellerId: traveller.id,
			gdsServices
		});
	});

	return travellerServices;
};
